import GameConfig from './GameConfig';
import GameModel from './GameModel';
import {distance, lerp} from '../utils';
import * as PIXI from 'pixi.js';
import GameUtils from './GameUtils';
import {DamageWall} from './actions/DamageWall';
import {Game} from './Game';
import {Location} from '../common/map/Location';

import Point = PIXI.Point;
import Sprite = PIXI.Sprite;

export class Projectile {
    private static gravity: number = 1;
    private static speedFactor: number = 6;

    private sprite?: Sprite;
    private duration: number;
    private velocity: Point;

    private static projectileId = 1;

    public static nextId(): number {
        return Projectile.projectileId++;
    }

    public constructor(public source: Point, private target: Point, private startAt: number) {
        // Just sets passed properties
    }

    public start(): void {
        this.startAt = Date.now();
        const dist = distance(this.source, this.target);
        this.duration = dist / Projectile.speedFactor;
        this.velocity = new Point(
            (this.target.x - this.source.x) / this.duration,
            (0.5 * Projectile.gravity * this.duration ** 2) / this.duration
        );
        this.sprite = this.makeSprite();
        GameModel.cannonballsContainer.addChild(this.sprite);
    }

    public finish(): void {
        if (!this.sprite) return;
        GameModel.cannonballsContainer.removeChild(this.sprite);
    }

    public tick(game: Game): boolean {
        if (this.isAlive()) {
            if (this.sprite) {
                this.sprite.position = this.spritePosition();
            }
            return true;
        } else {
            if (this.sprite) {
                GameModel.cannonballsContainer.removeChild(this.sprite);
                this.sprite.destroy();
                this.sprite = undefined;
            }
            new DamageWall(game).byClient(Location.fromPoint(this.target).floored());
            return false;
        }
    }

    private isAlive(): boolean {
        return this.time() < 1;
    }

    private spritePosition(): Point {
        const tileSize = GameConfig.tileSize;
        const t = this.time();
        const time = t * this.duration;
        const height = this.velocity.y * time - 0.5 * Projectile.gravity * time ** 2;
        const tileCurved = lerp(this.source, this.target, t);
        return new Point(tileCurved.x * tileSize, (tileCurved.y - height * 5) * tileSize);
    }

    private makeSprite(): Sprite {
        const texture = GameUtils.spriteTexture('cannonball');
        const sprite = new PIXI.Sprite(texture);
        sprite.position = this.spritePosition();
        sprite.scale.set(0.2, 0.2);
        sprite.tint = 0x202020;
        return sprite;
    }

    // [0,1] when alive, outside of that range when dead
    private time(): number {
        const dt = (Date.now() - this.startAt) / 1000;
        const aliveTime = this.duration;
        return dt / aliveTime;
    }
}



// WEBPACK FOOTER //
// ./src/game/Projectile.ts